// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-title {
  font-size: 1.1rem;
  font-weight: 600;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 8px;
  margin-bottom: 0;
}
 
.material-name {
  font-style: italic;
  font-weight: 400;
  color: #555;
}
 
.dialog-content {
  min-width: 500px;
  max-width: 640px;
  padding-top: 12px !important;
}
 
/* ── Status banner ──────────────────────────────────────────────────── */
.status-banner {
  text-align: center;
  font-weight: 600;
  font-size: 0.95rem;
  padding: 10px 16px;
  border-radius: 4px;
  margin-bottom: 14px;
  border: 2px solid;
}
 
.status-banner.scanning {
  color: #b22222;
  border-color: #b22222;
  background: #fff5f5;
}
 
.status-banner.weighing {
  color: #1a5276;
  border-color: #1a5276;
  background: #eaf4fb;
}
 
.status-banner.review {
  color: #145a32;
  border-color: #145a32;
  background: #eafaf1;
}
 
/* ── Form sections ──────────────────────────────────────────────────── */
.form-section {
  margin-bottom: 16px;
}
 
.section-title {
  font-size: 0.9rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #444;
  margin-bottom: 8px;
}
 
.field-row {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  flex-wrap: wrap;
}
 
.field {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 160px;
}
 
.field-label {
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
}
 
.field-input {
  max-width: 220px;
}
 
/* ── Scanner input (hidden, captures barcode reader keystrokes) ─────── */
.bmd-scanner-target-note {
  margin: -10px 0 14px;
  color: #374151;
  font-size: 0.9rem;
  text-align: center;
}
 
.bmd-scanner-input {
  position: fixed;
  left: -10000px;
  top: 0;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}
 
/* ── Field note (validation messages) ──────────────────────────────── */
.field-note {
  font-size: 0.85rem;
  margin-top: 6px;
  padding: 4px 8px;
  border-radius: 3px;
}
 
.field-note--warn {
  color: #7a4f00;
  background: #fff8e1;
  border-left: 3px solid #f0a500;
}
 
/* ── Scale note ─────────────────────────────────────────────────────── */
.scale-note {
  font-size: 0.85rem;
  color: #555;
  margin-top: 6px;
}
 
.scale-error {
  color: #b22222;
  font-weight: 600;
}
 
/* ── Submit button accent ───────────────────────────────────────────── */
.btn-submit:disabled {
  opacity: 0.5;
  cursor: default;
}
 
.button-gap {
  gap: 8px;
}
 
/* ── Checkbox styles ────────────────────────────────────────────────── */
.form-check {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-left: 0;
}
 
.form-check-input {
  margin: 0 !important;
  position: static !important;
}
 
.form-check-label {
  margin: 0;
}
 
 
.bmd-check-cell {
  grid-column: 1 / 3;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
}
 
.bmd-check-cell input {
  width: 14px;
  height: 14px;
  margin: 0;
}
 
.bmd-container-grid button {
  grid-column: 4;
  width: 266px;
  min-height: 40px;
  font-size: 18px;
}
 
.bmd-notes {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
  font-size: 18px;
  margin-left: 59px;
}
 
.bmd-error {
  color: #dc2626;
}
 
.bmd-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px;
  border-top: 1px solid #e2e8f0;
  margin-top: 0;
}
 
.bmd-actions button {
  width: 100px;
  min-height: 34px;
  font-size: 18px;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/spacer-details/batches/mud-measure-dialog/mud-measure-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,0EAA0E;AAC1E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,0EAA0E;AAC1E;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0EAA0E;AAC1E;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,MAAM;EACN,UAAU;EACV,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,0EAA0E;AAC1E;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,0EAA0E;AAC1E;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,QAAQ;AACV;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;AACX;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,aAAa;EACb,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".dialog-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  border-bottom: 1px solid #dee2e6;\n  padding-bottom: 8px;\n  margin-bottom: 0;\n}\n \n.material-name {\n  font-style: italic;\n  font-weight: 400;\n  color: #555;\n}\n \n.dialog-content {\n  min-width: 500px;\n  max-width: 640px;\n  padding-top: 12px !important;\n}\n \n/* ── Status banner ──────────────────────────────────────────────────── */\n.status-banner {\n  text-align: center;\n  font-weight: 600;\n  font-size: 0.95rem;\n  padding: 10px 16px;\n  border-radius: 4px;\n  margin-bottom: 14px;\n  border: 2px solid;\n}\n \n.status-banner.scanning {\n  color: #b22222;\n  border-color: #b22222;\n  background: #fff5f5;\n}\n \n.status-banner.weighing {\n  color: #1a5276;\n  border-color: #1a5276;\n  background: #eaf4fb;\n}\n \n.status-banner.review {\n  color: #145a32;\n  border-color: #145a32;\n  background: #eafaf1;\n}\n \n/* ── Form sections ──────────────────────────────────────────────────── */\n.form-section {\n  margin-bottom: 16px;\n}\n \n.section-title {\n  font-size: 0.9rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #444;\n  margin-bottom: 8px;\n}\n \n.field-row {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n \n.field {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 160px;\n}\n \n.field-label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  margin-bottom: 4px;\n  color: #333;\n}\n \n.field-input {\n  max-width: 220px;\n}\n \n/* ── Scanner input (hidden, captures barcode reader keystrokes) ─────── */\n.bmd-scanner-target-note {\n  margin: -10px 0 14px;\n  color: #374151;\n  font-size: 0.9rem;\n  text-align: center;\n}\n \n.bmd-scanner-input {\n  position: fixed;\n  left: -10000px;\n  top: 0;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  pointer-events: none;\n}\n \n/* ── Field note (validation messages) ──────────────────────────────── */\n.field-note {\n  font-size: 0.85rem;\n  margin-top: 6px;\n  padding: 4px 8px;\n  border-radius: 3px;\n}\n \n.field-note--warn {\n  color: #7a4f00;\n  background: #fff8e1;\n  border-left: 3px solid #f0a500;\n}\n \n/* ── Scale note ─────────────────────────────────────────────────────── */\n.scale-note {\n  font-size: 0.85rem;\n  color: #555;\n  margin-top: 6px;\n}\n \n.scale-error {\n  color: #b22222;\n  font-weight: 600;\n}\n \n/* ── Submit button accent ───────────────────────────────────────────── */\n.btn-submit:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n \n.button-gap {\n  gap: 8px;\n}\n \n/* ── Checkbox styles ────────────────────────────────────────────────── */\n.form-check {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-left: 0;\n}\n \n.form-check-input {\n  margin: 0 !important;\n  position: static !important;\n}\n \n.form-check-label {\n  margin: 0;\n}\n \n \n.bmd-check-cell {\n  grid-column: 1 / 3;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 0;\n}\n \n.bmd-check-cell input {\n  width: 14px;\n  height: 14px;\n  margin: 0;\n}\n \n.bmd-container-grid button {\n  grid-column: 4;\n  width: 266px;\n  min-height: 40px;\n  font-size: 18px;\n}\n \n.bmd-notes {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 8px;\n  font-size: 18px;\n  margin-left: 59px;\n}\n \n.bmd-error {\n  color: #dc2626;\n}\n \n.bmd-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 10px;\n  border-top: 1px solid #e2e8f0;\n  margin-top: 0;\n}\n \n.bmd-actions button {\n  width: 100px;\n  min-height: 34px;\n  font-size: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
